/* eslint-disable no-param-reassign */
/* eslint-disable default-param-last */
import { produce } from 'immer';

import {
  TOGGLE_SPOT_MODAL,
  SET_PANEL_MODE,
  SET_CAME_FROM_TRADE,
  SET_ASSET_CHANGE_DISABLED,
  SET_TRANSFER_AMOUNT,
} from 'actionTypes/spot';

export type PanelMode = 'trade' | 'transfer' | 'history' | null | '';

export interface ISpot {
  isSpotModalOpen: boolean;
  panelMode: PanelMode;
  cameFromTrade: boolean;
  isAssetChangeDisabled: boolean;
  transferAmount: string;
}

const initialState: ISpot = {
  isSpotModalOpen: false,
  panelMode: null,
  cameFromTrade: false,
  isAssetChangeDisabled: false,
  transferAmount: '',
};

const spotReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SPOT_MODAL:
      draft.isSpotModalOpen = action.payload;
      break;
    case SET_PANEL_MODE:
      // Handle empty object from createAction helper
      draft.panelMode =
        action.payload && Object.keys(action.payload).length === 0
          ? null
          : action.payload;
      break;
    case SET_CAME_FROM_TRADE:
      draft.cameFromTrade = action.payload;
      break;
    case SET_ASSET_CHANGE_DISABLED:
      draft.isAssetChangeDisabled = action.payload;
      break;
    case SET_TRANSFER_AMOUNT:
      draft.transferAmount = action.payload;
      break;
    default:
      break;
  }
  return draft;
});

export default spotReducer;
